export default "__VITE_ASSET__8c99f10c__"